<div class="w-p-100 flex">
    <div *ngIf="isReady" class="simple-scroll flex flex-col w-p-100">
        <!-- FM-E-55: per-section Include header. The button renders iff the server stamped
             SectionCanInclude (a read-only section on a non-Admin-locked form); an already-included
             section shows a subtle "Included" hint instead. -->
        <div class="section-include-header flex flex-row justify-end items-center"
             *ngIf="sectionCanInclude || isSectionIncluded">
            <button mat-button type="button" class="section-include-button" *ngIf="sectionCanInclude"
                    matTooltip="Include this section in the amendment and make it editable"
                    (click)="onIncludeSection(); $event.stopPropagation()">
                <i class="fa-regular fa-plus"></i> Include
            </button>
            <span class="section-included-hint" *ngIf="!sectionCanInclude && isSectionIncluded">
                <i class="fa-regular fa-check"></i> Included
            </span>
        </div>
        <form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm" [ngStyle]="formGridStyle"
              class="app-platform-tool-dialog-definition-container-form">
            <ng-container *ngFor="let field of dialogFields$ | async; trackBy: trackById">
                <div [id]="field.key +'--'+ itemId"
                     [ngStyle]="field.styles | apiColourStyles">
                    <div class="flex flex-col">
                        <div class="flex flex-row">
                            <div class="m-b-8 flex flex-row items-center headers flex-1" *ngIf="field.fieldValues['FieldHeader']" >
                                <span class="header-text" title="{{field.fieldValues['FieldHeader']}}">{{field.fieldValues['FieldHeader']}}</span>
                                <!-- Shown only when the field has a scenario mapping defined
                                     (backend stamps HasScenarioMapping from the field's MappedFieldKey
                                     in EliteFormService.ConvertToDialogField). -->
                                <i *ngIf="field.fieldValues['HasScenarioMapping']"
                                   class="fa-regular fa-diagram-project mapping-indicator"
                                   title="This field is automatically populated via data mapping."
                                   aria-label="This field is automatically populated via data mapping."></i>
                            </div>
                            <!-- <div class="m-b-8 flex flex-row items-center gap-1" *ngIf="field.fieldValues['FieldHeader']">

                            </div> -->
                            <button mat-icon-button type="button" *ngIf="field.type !== 'Group' && field.fieldValues['IsLocked']"
                                matTooltip="Unlock Field" class="icon-dropdown-button"
                                (click)="onLockField(field, false); $event.stopPropagation()"><i
                                    class="fa-regular fa-lock-open"></i>
                            </button>
                            <button mat-icon-button type="button" *ngIf="field.fieldValues['LockEnabled'] && !field.fieldValues['IsLocked']"
                                matTooltip="Lock Field" class="icon-dropdown-button"
                                (click)="onLockField(field, true); $event.stopPropagation()"><i
                                    class="fa-regular fa-lock"></i>
                            </button>
                            <button mat-icon-button type="button" *ngIf="field.fieldValues['DefaultValueChanged'] && field.fieldValues.hasOwnProperty('DefaultValue') && !field.fieldValues['IsLocked']"
                                matTooltip="Restore Data" class="icon-dropdown-button"
                                (click)="onRestoreField(field); $event.stopPropagation()"><i
                                    class="fa-regular fa-rotate-left"></i>
                            </button>
                            <button mat-icon-button type="button" *ngIf="field.fieldValues['Details']"
                                matTooltip="View Details" class="icon-dropdown-button"
                                (click)="openDetailsAndInstructions(field); $event.stopPropagation()"><i
                                    class="fa-regular fa-circle-info"></i>
                            </button>
                        </div>


                        <app-platform-tool-dialog-definition-editor-container [dialogField]="field"
                                                                              [platformDialog]="platformDialog"
                                                                              *ngIf="field.type !== 'Group' && !field.fieldValues['IsMultiResponseField']"
                                                                              [inputForm]="inputForm"
                                                                              (fieldValueChange)="onFieldValueChange($event, field)"
                                                                              (fieldValidationChange)="onFieldValidationChange($event)"
                                                                              (fieldDestroy)="onFieldDestroy($event)"
                                                                              [extras]="{}">
                        </app-platform-tool-dialog-definition-editor-container>
                    </div>

                    <app-elite-form-group-container [ngStyle]="field.styles | apiColourStyles"
                                                    *ngIf="field.type === 'Group' || field.fieldValues['IsMultiResponseField']"
                                                    [platformDialog]="platformDialog" [parentFormGroup]="inputForm"
                                                    [dialogField]="field">
                    </app-elite-form-group-container>
                </div>
            </ng-container>
            <div [ngStyle]="getFakeDivStyle()"></div>
        </form>
    </div>
</div>
